import styles from "./Toast.module.css";
import { CheckCircleIcon } from "../../../icons/CheckCircleIcon";
import { AlertCircleIcon } from "../../../icons/AlertCircleIcon";
import { InfoIcon } from "../../../icons/InfoIcon";
import { XIcon } from "../../../icons/XIcon";

type ToastVariant = "success" | "error" | "info";

const VARIANT_ICONS: Record<ToastVariant, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  success: CheckCircleIcon,
  error: AlertCircleIcon,
  info: InfoIcon,
};

interface ToastProps {
  readonly variant: ToastVariant;
  readonly message: string;
  readonly onDismiss: () => void;
}

export function Toast({ variant, message, onDismiss }: ToastProps) {
  const Icon = VARIANT_ICONS[variant];

  return (
    <div className={`${styles.toast} ${styles[variant]}`}>
      <Icon className={styles.icon} width={20} height={20} aria-hidden="true" />
      <p className={styles.message}>{message}</p>
      <button type="button" onClick={onDismiss} className={styles.dismiss} aria-label="Dismiss">
        <XIcon width={14} height={14} />
      </button>
    </div>
  );
}
